import { FILE_UPLOAD_SINGLE_FILE_UPLOAD_SUCCESS } from '../actions';
import { createFileUploadSuccessState } from '../services';
export const fileUploadSuccessRootReducer = (state = createFileUploadSuccessState(), action) => {
    switch (action.type) {
        case FILE_UPLOAD_SINGLE_FILE_UPLOAD_SUCCESS:
            return Object.assign(Object.assign({}, state), { byId: Object.assign(Object.assign({}, state.byId), { [action.payload.id]: Object.assign(Object.assign({}, state[action.payload.id]), { headers: action.payload.headers }) }), allIds: [...Array.from(new Set(state.allIds.concat(action.payload.id)))] });
        default:
            return state;
    }
};
//# sourceMappingURL=fileUploadSuccessRootReducer.js.map